import React, { useState } from 'react'

import decryptJWT from '../../../utils/decryptJWT'
import Icone from '../../Icone'

import ClientesConectados from './ClientesConectados'
import Consumo from './Consumo'
import Historico from './Historico'
import Localizacao from './Localizacao'
import Simcards from './Simcards'
import * as S from './styles'

const OPCOES_DEFAULT = [
  {
    type: 'localizacao',
    label: 'Localização',
    icone: {
      nome: 'localizacao',
      width: '22px',
      height: '22px'
    }
  },
  {
    type: 'simcards',
    label: 'SIM cards',
    icone: {
      nome: 'simcard',
      width: '22px',
      height: '22px'
    }
  },
  {
    type: 'clientes_conectados',
    label: 'Clientes conectados',
    icone: {
      nome: 'cliente',
      width: '22px',
      height: '22px'
    }
  },
  {
    type: 'historico',
    label: 'Histórico de conexões',
    icone: {
      nome: 'historico',
      width: '22px',
      height: '22px'
    }
  },
  {
    type: 'consumo',
    label: 'Histórico de consumo',
    icone: {
      nome: 'icone-detalhamento-consumo',
      width: '22px',
      height: '22px'
    }
  }
]

export default function DetalhamentoLinha({
  setAuxAcaoMostrarEmDispositivos,
  row,
  onUpdateLocation
}) {
  const [menuSelecionado, setMenuSelecionado] = useState('')
  const isLocalizacao = menuSelecionado === 'localizacao'
  const isSimcards = menuSelecionado === 'simcards'
  const isClientesConectados = menuSelecionado === 'clientes_conectados'
  const isHistorico = menuSelecionado === 'historico'
  const isConsumo = menuSelecionado === 'consumo'

  const isClienteValido = () => decryptJWT('codigoCliente') == 1
  const OPCOES = OPCOES_DEFAULT.filter((i) => {
    if (i.type === 'clientes_conectados') return isClienteValido()
    return true
  })

  return (
    <S.Container>
      <S.Opcoes itens={OPCOES.length}>
        {OPCOES.map((item) => (
          <S.Opcao
            onClick={() => setMenuSelecionado(item.type)}
            key={item.type}
          >
            <Icone
              nome={item.icone.nome}
              color={item.type === menuSelecionado ? 'primary' : 'default'}
              width={item.icone.width}
              height={item.icone.height}
            />
            <S.Label selected={item.type === menuSelecionado}>
              {item.label}
            </S.Label>
          </S.Opcao>
        ))}
      </S.Opcoes>
      <S.GlobalStyles />
      {isLocalizacao && (
        <Localizacao row={row} onUpdateLocation={onUpdateLocation} />
      )}
      {isSimcards && <Simcards cdPortadora={row.id} />}
      {isClientesConectados && (
        <ClientesConectados
          setAuxAcaoMostrarEmDispositivos={setAuxAcaoMostrarEmDispositivos}
          cdPortadora={row.id}
        />
      )}
      {isHistorico && <Historico cdPortadora={row.id} />}
      {isConsumo && <Consumo cdPortadora={row.id} />}
    </S.Container>
  )
}
